import router from '@/router';

import Page from './module/page.vue'
import Scan from './module/scan.vue'
import Topbar from './module/topbar.vue'
import TopbarLink from './module/topbar_link.vue'
import TopbarHandle from './module/topbar_handle.vue'
import ViewList from './module/view_list.vue'
import ViewListCard from './module/view_list_card.vue'
import ViewListTotal from './module/view_list_total.vue'

import DetailBase from './module/detail_base.vue'
import DetailContent from './module/detail_content.vue'
import DetailHandle from './module/detail_handle.vue'

import DetailCard from './module/detail_card.vue'
import DetailCardForm from './module/detail_card_form.vue'
import DetailCardList from './module/detail_card_list.vue'
import DetailCardListRow from './module/detail_card_list_row.vue'

import CustomForm from './module/custom_form.vue'
import CustomDetail from './module/custom_detail.vue'

import Search from './module/search.vue'
import SearchItem from './module/search_item.vue'

import Field from './public/field.vue'
import State from './public/state.vue'
import Tags from './public/tags.vue'
import FileList from './public/file_list.vue'
import ScanCode from './public/scan_code.vue'
import ProcessRate from './public/process_rate.vue'
import DetailBar from './public/detail_bar.vue'
import HandleBar from './public/handle_bar.vue'
import SelectOption from './public/select_option.vue'
import ReasonOption from './public/reason_option.vue'
import timePicker from './public/time_picker.vue'
import InfoCard from './public/info_card.vue'
import CutLine from './public/cut_line.vue'
import InsertData from './public/insert_data.vue'
import Tips from './public/tips.vue'
import File from './public/file.vue'
import Location from './public/location.vue'

import UploadFile from './extand/upload_file.vue'

const COMPS = [
	Page,
	Scan,
	Topbar,
	TopbarLink,
	TopbarHandle,
	ViewList,
	ViewListCard,
	ViewListTotal,

	DetailBase,
	DetailContent,
	DetailHandle,

	DetailCard,
	DetailCardForm,
	DetailCardList,
	DetailCardListRow,

	CustomForm,
	CustomDetail,

	Search,
	SearchItem,

	Field,
	State,
	Tags,
	FileList,
	ScanCode,
	ProcessRate,
	DetailBar,
	HandleBar,
	SelectOption,
	ReasonOption,
	timePicker,
	InfoCard,
	CutLine,
	InsertData,
	Tips,
	File,
	Location,

	UploadFile
]

const DYNAMIC_COMPS = [
];

// 导出组件
export default {
	install: function(Vue) {
		COMPS.forEach(comp => {
			Vue.component(comp.name, comp);
		})

		DYNAMIC_COMPS.forEach(comp => {
			let constructor = Vue.extend(comp);
			Vue.prototype[`$${comp.name}`] = function(opt = {}) {
				opt.dom = opt.dom || document.body
				let vm = new constructor({
					router,
					el: document.createElement('div'),
					data() {
						return opt
					}
				});

				if (opt.events) {
					for (let event in opt.events) {
						vm.$on(event, opt.events[event]);
					}
				}

				opt.dom.appendChild(vm.$el);
				return vm;
			}
		});
	}
}